export class Misc {
    public static Translate(str: string, translation: Record<string, string>): string {
        for (const [key, value] of Object.entries(translation)) str = str.replace(new RegExp(`{{${key}}}`, "g"), value);
        return str;
      };
}